<template>

  <div class="quiz-container">
    <div class="question-container" v-if="state === 'quiz'">

      <question v-bind:question="questions[activeQuestion]" @next="nextQuestion($event)"></question>
    </div>
    <div class="result-container" v-if="state === 'result'">

      <div class="result" v-bind:style="{'background-image':'url(' + results[result].image + ')'      }">
        <div class="title">{{score}} / {{this.questions.length}} <br> {{results[result].title}}</div>
        <div class="text">{{results[result].text}}</div>
        <div class="share-block">
          <div class="shares-links">
            <social-sharing :url="'http://quiz-result.afisha.ru/result/?result=result-'+results[result].id"
                            title="Эмодзи тест"
                            description="Помните ли вы заголовки из фильмов?"
                            quote="Помните ли вы заголовки из фильмов?"
                            v-cloak inline-template>
              <div class="share-links">
                <div class="share-item" @click="$ga.event('Шаринг', 'Шаринг вконтакте', 1)">
                  <network network="vk" id="vk">
                    <i class="icon icon-vk"></i>
                  </network>
                </div>
                <div class="share-item" @click="$ga.event('Шаринг', 'Шаринг facebook', 1)">
                  <network network="facebook" id="facebook">
                    <i class="icon icon-facebook"></i>
                  </network>
                </div>
                <div class="share-item" @click="$ga.event('Шаринг', 'Шаринг twitter', 1)">
                  <network network="twitter" id="twitter">
                    <i class="icon icon-twitter"></i>
                  </network>
                </div>
                <div class="share-item" @click="$ga.event('Шаринг', 'Шаринг одноклассники', 1)">
                  <network network="odnoklassniki" id="odnoklassniki">
                    <i class="icon icon-odnoklassniki"></i>
                  </network>
                </div>
              </div>
            </social-sharing>
          </div>
        </div>

      </div>
      <button @click="startNew">повторить тест</button>

    </div>
  </div>
</template>

<script>
    import Question from "../components/Question";

    export default {
        name: "Quiz",

        data() {
            return {
                state: "quiz",
                activeQuestion: 0,
                score: 0,
                questions: [
                    {
                        id: 0,
                        text1:
                            "—  Борис, этот Френки Четыре Пальца имеет при себе бриллиант размером с ",
                        text1_2: ". Я тебе уже говорил, что бриллиант лежит в ",
                        text2_3:
                            ", который пристегнут к его руке. Я послал его к тебе купить",
                        text3: ".",
                        subText: "Фильм: Большой Куш",
                        answer: ["1_1_1", "1_2_1", "1_3_1"],
                        variants: [
                            ["1_1_1", "1_1_2", "1_1_3"],
                            ["1_2_1", "1_2_2", "1_2_3"],
                            ["1_3_1", "1_3_2", "1_3_3"]
                        ]
                    },
                    {
                        id: 1,
                        text1: "— Джон, даже в моей профессии есть один непреложный ",
                        text1_2: ". Я никогда не прошу клиентов судить меня по ",
                        text2_3: ". Я прошу их судить меня по ",
                        text3: ". Потому что их очень мало.",
                        subText: "Фильм: Волк с Уолл-стрит",
                        answer: ["2_1_1", "2_2_1", "2_3_1"],
                        variants: [
                            ["2_1_1", "2_1_2", "2_1_3"],
                            ["2_2_1", "2_2_2", "2_2_3"],
                            ["2_3_1", "2_3_2", "2_3_3"]
                        ]
                    },
                    {
                        id: 2,
                        text1: "— Я искал тебя, Нео. ",
                        text1_2:
                            ", готов ли ты увидеть то, что должен, но, увы, у нас время на исходе. За тобой ",
                        text2_3: ". И я не знаю, что они ",
                        text3: ".",
                        subText: "Фильм: Матрица",
                        answer: ["3_1_1", "3_2_1", "3_3_1"],
                        variants: [
                            ["3_1_1", "3_1_2", "3_1_3"],
                            ["3_2_1", "3_2_2", "3_2_3"],
                            ["3_3_1", "3_3_2", "3_3_3"]
                        ]
                    },
                    {
                        id: 3,
                        text1: "—  Вы проникли в мое хранилище, поздравляю — вы ",
                        text1_2:
                            ". Вы надеетесь выбраться оттуда? Или полагаете, что я позволю вам выйти из ",
                        text2_3: " парадным строем с ",
                        text3: "?",
                        subText: "Фильм: Одиннадцать друзей Оушена",
                        answer: ["4_1_1", "4_2_1", "4_3_1"],
                        variants: [
                            ["4_1_1", "4_1_2", "4_1_3"],
                            ["4_2_1", "4_2_2", "4_2_3"],
                            ["4_3_1", "4_3_2", "4_3_3"]
                        ]
                    },
                    {
                        id: 4,
                        text1: "— Я не собираюсь ",
                        text1_2:
                            "вас, Кларисса, с вами мир интереснее, прошу и вас отнестись ко мне столь же учтиво. Рад был бы ",
                        text2_3: " подольше, но ко мне на ",
                        text3: "пожаловал старый друг.",
                        subText: "Фильм: Молчание ягнят",
                        answer: ["5_1_1", "5_2_1", "5_3_1"],
                        variants: [
                            ["5_1_1", "5_1_2", "5_1_3"],
                            ["5_2_1", "5_2_2", "5_2_3"],
                            ["5_3_1", "5_3_2", "5_3_3"]
                        ]
                    },
                    {
                        id: 5,
                        text1: "— Если ты отпустишь мою ",
                        text1_2: " — на этом все закончится, я не буду тебя ",
                        text2_3:
                            "и не буду преследовать, но если не отпустишь — я тебе обещаю, я тебя найду и ",
                        text3: "!",
                        subText: "Фильм: Заложница",
                        answer: ["6_1_1", "6_2_1", "6_3_1"],
                        variants: [
                            ["6_1_1", "6_1_2", "6_1_3"],
                            ["6_2_1", "6_2_2", "6_2_3"],
                            ["6_3_1", "6_3_2", "6_3_3"]
                        ]
                    },
                    {
                        id: 6,
                        text1: "— Не надо мне никаких гребаных «если». Я хочу ",
                        text1_2:
                            " только одно: «Нет проблем, Джулс, я тебя вытащу. Иди в дом, успокой народ, жди кавалерию, она уже давно к тебе ",
                        text2_3: "». <br>" + "— Да нет проблем, Джулс. Я тебя вытащу. Иди в ",
                        text3: ", успокой народ и жди Вульфа, он скоро будет.",
                        subText: "Фильм: Криминальное чтиво ",
                        answer: ["7_1_1", "7_2_1", "7_3_1"],
                        variants: [
                            ["7_1_1", "7_1_2", "7_1_3"],
                            ["7_2_1", "7_2_2", "7_2_3"],
                            ["7_3_1", "7_3_2", "7_3_3"]
                        ]
                    },
                    {
                        id: 7,
                        text1: "—  Кто это?<br>—  Тот, кому нравится ",
                        text1_2: " за тобой. Сегодня мне нравится твой ",
                        text2_3: " черный, с малиновым мороженым. Весьма ",
                        text3: ".",
                        subText: "Фильм: Телефонная будка",
                        answer: ["8_1_1", "8_2_1", "8_3_1"],
                        variants: [
                            ["8_1_1", "8_1_2", "8_1_3"],
                            ["8_2_1", "8_2_2", "8_2_3"],
                            ["8_3_1", "8_3_2", "8_3_3"]
                        ]
                    },
                    {
                        id: 8,
                        text1: "—  Я ",
                        text1_2: " самаритянин. Извините, что звоню в столь ",
                        text2_3: " час, просто я решил, что вы ",
                        text3: "волнуетесь, куда подевалась ваша хрень.",
                        subText: "Фильм: После прочтения сжечь",
                        answer: ["9_1_1", "9_2_1", "9_3_1"],
                        variants: [
                            ["9_1_1", "9_1_2", "9_1_3"],
                            ["9_2_1", "9_2_2", "9_2_3"],
                            ["9_3_1", "9_3_2", "9_3_3"]
                        ]
                    },
                    {
                        id: 9,
                        text1: "— Петр Александрович, ваша ",
                        text1_2: " отменяется. <…> Я прекращаю работу в Москве и вообще в ",
                        text2_3:
                            "… Сейчас ко мне вошли четверо, из них одна женщина, переодетая ",
                        text3: ", и двое вооруженных револьверами, и терроризировали меня.",
                        subText: "Фильм: Собачье сердце",
                        answer: ["10_1_1", "10_2_1", "10_3_1"],
                        variants: [
                            ["10_1_1", "10_1_2", "10_1_3"],
                            ["10_2_1", "10_2_2", "10_2_3"],
                            ["10_3_1", "10_3_2", "10_3_3"]
                        ]
                    }
                ],
                result: 0,
                results: [
                    {
                        id: 1,
                        image: require('../assets/result-1.jpg'),
                        title: 'Вы — Люси из «Твин Пикса»',
                        text: "Не можете представить свою жизнь без разговоров по телефону, а мир эмодзи для вас — темный лес.",
                        shareImage:'http://quiz-result.afisha.ru/img/social-1.jpg'
                    },
                    {
                        id: 2,
                        image: require('../assets/result-2.jpg'),
                        title: 'Вы — Колин Фаррелл из «Телефонной будки»',
                        text: "Рады бы побыстрее закончить разговор, но вы заложник вашего телефона.",
                        shareImage:'http://quiz-result.afisha.ru/img/social-2.jpg'

                    },
                    {
                        id: 3,
                        image: require('../assets/result-3.jpg'),
                        title: 'Вы — точно из «Черного зеркала»',
                        shareImage:'http://quiz-result.afisha.ru/img/social-3.jpg',
                        text: "Вы человек эпохи «Черного зеркала» — легко можете обойтись без слов и жить только с эмодзи. "
                    },

                ]
            };
        },
        mounted: function () {
          this.sendStartGa();

        },
        methods: {
            sendStartGa(){
                var that = this;
                setTimeout(function () {
                    that.$ga.event('Тест', 'Начало теста', 1);
                    that.$ga.event('Тест', 'Просмотр вопроса №1', 1);
                },800);
            },
            nextQuestion(answer) {
                if (answer === true) {
                    this.score++;
                    this.$ga.event('Тест', 'Правильный ответ на  №' + (this.activeQuestion +1), 1);
                }
                else {
                    this.$ga.event('Тест', 'Неправильный ответ на  №' + (this.activeQuestion +1), 1);

                }

                if (this.activeQuestion + 1 == this.questions.length) {
                    this.$ga.event('Тест', `Результат:  ${this.score} очков`, 1);

                    this.result = 0;
                    if (this.score >= 4) this.result = 1;
                    if (this.score >= 7) this.result = 2;
                    this.state = "result";
                } else {
                    this.activeQuestion++;
                    this.$ga.event('Тест', 'Просмотр вопроса №' + (this.activeQuestion +1), 1);
                }
            },
            startNew() {
                this.score = 0;
                this.activeQuestion = 0;
                this.state = 'quiz';
                this.$ga.event('Тест', 'Начать заново', 1);


            }
        },

        components: {
            Question
        }
    };
</script>

<style  lang="scss">
  .quiz-container {
    width: 100%;
    max-width: 730px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .result-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 480px;
    width: 100%;
    .result {
      border: 4px solid #0047ff;
      border-bottom: 0;
      height: 100%;
      text-align: center;
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      background-position: top center;
      .title {
        font-weight: 700;
        font-size: 45px;
        margin-bottom: 10px;
      }
      .text{
        font-size: 30px;
        width: 90%;
        margin: 0 auto;
      }
    }
    button {
      width: 100%;
      height: 60px;
      text-align: center;
      align-items: center;
      border: 0;
      color: #ffffff;
      font-size: 13px;
      text-transform: uppercase;
      cursor: pointer;
      outline: 0;
      background-color: #0047ff;
      flex-shrink: 0;
    }

  }

  .share-links {
    margin-top: 20px;
  }

  .share-result {
    display: flex;
    align-items: center;
  }

  .shares-links {
    .icon {
      width: 25px !important;
      height: 25px !important;
    }
    .share-item{
      display: inline-flex;
      width: 48px;
      height: 48px;
      border: 1px solid white;
      align-items: center;
      justify-content: center;
      &:hover{
        background: rgba(0,0,0,0.4);
      }
    }
  }
  .icon {
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-position: center center;
    display: inline-flex;
    &:hover {
      opacity: 0.8;
    }
    &.icon-vk {
      background-image: url("../assets/icons/ico__vk.svg");
    }
    &.icon-facebook {
      background-image: url("../assets/icons/ico__fb.svg");
    }
    &.icon-twitter {
      background-image: url("../assets/icons/ico__tw.svg");
    }
    &.icon-odnoklassniki {
      background-image: url("../assets/icons/ico__ok.svg");
    }
  }

  @media screen and (max-width: 480px) {
    .result-container{
      .result{
        .title{
          font-size: 31px;
          line-height: 30px;
        }
        .text{
          font-size: 20px;
        }
      }
    }

  }
</style>
